// VisualPiano.tsx

import { forwardRef, ForwardRefRenderFunction } from "react";
import { Box } from "@chakra-ui/react";
import SubmitPiano from "components/piano/SubmitPiano";
import MidiNumbers from "../piano/MidiNumbers";

export interface VisualPianoProps {
  midiNumbers: number[];
}

// Define the type for the forwarded ref
export interface VisualPianoHandle {
  checkAnswer: () => boolean;
}

const VisualPiano: ForwardRefRenderFunction<
  VisualPianoHandle,
  VisualPianoProps
> = ({ midiNumbers }, ref) => {
  const firstNote = MidiNumbers.fromNote("c3");
  const lastNote = MidiNumbers.fromNote("b5");

  return (
    <Box textAlign="center" width="100%">
      <SubmitPiano
        noteRange={{
          first: firstNote || MidiNumbers.fromNote("c3"),
          last: lastNote || MidiNumbers.fromNote("b5"),
        }}
        keyColors={{}} // Define if necessary
        keyBorderColors={{}}
        activeNotes={midiNumbers}
        correctNotes={[]}
        isSubmitted={false}
        playNote={() => {}} // Define if necessary
        stopNote={() => {}} // Define if necessary
        width="100%"
        height="150px"
      />
    </Box>
  );
};

// Export the component using forwardRef with type annotations
export default forwardRef<VisualPianoHandle, VisualPianoProps>(VisualPiano);
